import React, { useEffect, useRef, useState } from 'react';

export default function StepTransition({ stepKey, children }) {
  const [phase, setPhase] = useState('enter');
  const [shownChildren, setShownChildren] = useState(children);
  const latestChildrenRef = useRef(children);
  const isTransitioningRef = useRef(false);
  const isFirstRender = useRef(true);
  const timerRef = useRef(null);

  latestChildrenRef.current = children;

  // Animate in on first mount
  useEffect(() => {
    requestAnimationFrame(() => {
      setPhase('visible');
    });
  }, []);

  // When stepKey changes: fade out old content, then swap and fade in
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    isTransitioningRef.current = true;
    setPhase('exit');

    timerRef.current = setTimeout(() => {
      setShownChildren(latestChildrenRef.current);
      isTransitioningRef.current = false;
      setPhase('visible');
    }, 600);

    return () => {
      clearTimeout(timerRef.current);
      isTransitioningRef.current = false;
    };
  }, [stepKey]);

  // Same-step children updates (e.g. NameStep greeting swap)
  useEffect(() => {
    if (!isTransitioningRef.current) {
      setShownChildren(children);
    }
  }, [children]);

  return (
    <div
      className={`transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${
        phase === 'visible'
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 -translate-y-3 pointer-events-none'
      }`}
    >
      {shownChildren}
    </div>
  );
}
